import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaBars, FaTimes, FaGlobe } from "react-icons/fa";
import "./Header.css"; 
import logo from "../Assets/logo.png";
import { useLanguage } from '../../Context/LanguageContext'; 

const Header = () => {
    const { 
        selectedLanguage,        
        setSelectedLanguage,    
        languageOptions,
        t 
    } = useLanguage(); 
    
    const [isDropdownVisible, setDropdownVisible] = useState(false);
    const [isLanguageDropdownVisible, setLanguageDropdownVisible] = useState(false);
    
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);
    const [menuOpen, setMenuOpen] = useState(false);
    const [isMobileLanguageOpen, setMobileLanguageOpen] = useState(false);

    const navigate = useNavigate();
    const menuRef = useRef();
    const languageDropdownRef = useRef();

    const closeDropdown = () => {
        setDropdownVisible(false);
        setLanguageDropdownVisible(false);
        setMobileLanguageOpen(false);
        setMenuOpen(false);
        if (menuRef.current) {
            menuRef.current.classList.remove("nav-menu-visible");
        }
    };

    const dropdown_toggle = () => {
        setMenuOpen(!menuOpen);
        setMobileLanguageOpen(false);
        if (menuRef.current) {
            menuRef.current.classList.toggle("nav-menu-visible");
        }
    };

    const toggleMobileLanguage = () => {
        setMobileLanguageOpen(!isMobileLanguageOpen);
        setMenuOpen(false);
        if (menuRef.current) {
            menuRef.current.classList.remove("nav-menu-visible");
        }
    };

    const handleLanguageSelect = (langName) => { 
        setSelectedLanguage(langName); 
        setLanguageDropdownVisible(false);
        setMobileLanguageOpen(false);
        closeDropdown();
    };

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 800);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                !event.target.closest(".nav_dropdown")
            ) {
                setMenuOpen(false);
                menuRef.current.classList.remove("nav-menu-visible");
            }

            if (
                languageDropdownRef.current &&
                !languageDropdownRef.current.contains(event.target) &&
                !isMobile
            ) {
                setLanguageDropdownVisible(false);
            }

            if (
                isMobile &&
                !event.target.closest(".language-dropdown.mobile-language-header")
            ) {
                setMobileLanguageOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isMobile]);
    

    return (
        <header className="header">
            <div className="logo">
                <img src={logo} alt="logo" /> 
            </div>

            {isMobile && (
                <div className="mobile-header-actions">
                    <li
                        className={`dropdown language-dropdown mobile-language-header ${isMobileLanguageOpen ? 'open' : ''}`}
                        onClick={toggleMobileLanguage}
                    >
                        <span className="language-selector-span current-language" >
                            <FaGlobe /> {selectedLanguage.substring(0, 3)} 
                        </span>
                        {isMobileLanguageOpen && (
                            <ul className="dropdown-menu language-menu mobile-dropdown-menu">
                                {languageOptions.map((lang) => (
                                    <li key={lang.code}>
                                        <span onClick={() => handleLanguageSelect(lang.name)} role="button">
                                            {lang.name}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </li> 

                    <div
                        className="nav_dropdown"
                        onClick={dropdown_toggle}
                        aria-label={menuOpen ? "Close menu" : "Open menu"}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") dropdown_toggle();
                        }}
                    >
                        {menuOpen ? <FaTimes /> : <FaBars />}
                    </div>
                </div>
            )}


            <ul ref={menuRef} className="nav-links"> 

                {!isMobile && (
                    <>
                        <li
                            className="dropdown language-dropdown"
                            onMouseEnter={() => setLanguageDropdownVisible(true)}
                            onMouseLeave={() => setLanguageDropdownVisible(false)}
                            ref={languageDropdownRef}
                        >
                            <span className="language-selector-span" >
                                <FaGlobe /> {selectedLanguage} 
                            </span>
                            {isLanguageDropdownVisible && (
                                <ul className="dropdown-menu language-menu">
                                    {languageOptions.map((lang) => (
                                        <li key={lang.code}>
                                            <span
                                                onClick={() => handleLanguageSelect(lang.name)} 
                                                tabIndex={0}
                                                onKeyDown={(e) => { if (e.key === "Enter") handleLanguageSelect(lang.name); }}
                                                role="button"
                                            >
                                                {lang.name}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                        
                        <li>
                            <Link to="/" onClick={closeDropdown}>{t.nav_home}</Link>
                        </li>
                        
                        {/* =========================== */}
                        {/* SERVICES HIDDEN ON DESKTOP */}
                        {/* =========================== */}
                        {false && (
                            <li
                                className="dropdown"
                                onMouseEnter={() => setDropdownVisible(true)}
                                onMouseLeave={() => setDropdownVisible(false)}
                            >
                                <Link to="/services" onClick={closeDropdown}>
                                    {t.nav_services}
                                </Link>

                                {isDropdownVisible && (
                                    <ul className="dropdown-menu">
                                        <li><Link to="/services/web-development" onClick={closeDropdown}>{t.sub_web_dev}</Link></li>
                                        <li><Link to="/services/app-development" onClick={closeDropdown}>{t.sub_app_dev}</Link></li>
                                        <li><Link to="/services/dashboard" onClick={closeDropdown}>{t.sub_data_analysis}</Link></li>
                                        <li><Link to="/services/tutorial" onClick={closeDropdown}>{t.sub_tutorial}</Link></li>
                                        <li><Link to="/services/electrical" onClick={closeDropdown}>{t.sub_electrical}</Link></li>
                                    </ul>
                                )}
                            </li>
                        )}

						 <li><Link to="/contact" onClick={closeDropdown}>{t.nav_contact}</Link></li>
                        <li><Link to="/download1" onClick={closeDropdown}>{t.nav_download}</Link></li>
                        <li><Link to="/login" className="logout-btn" onClick={closeDropdown}>{t.nav_login_signup}</Link></li>
                    </>
                )}

                {isMobile && (
                    <>
                        <li>
                            <Link to="/" onClick={closeDropdown}>{t.nav_home}</Link>
                        </li>

                        {/* ========================= */}
                        {/* SERVICES HIDDEN ON MOBILE */}
                        {/* ========================= */}
                        {false && (
                            <>
                                <li className="section-title">— {t.nav_services} —</li>

                                <li><Link to="/services/web-development" onClick={closeDropdown}>{t.sub_web_dev}</Link></li>
                                <li><Link to="/services/app-development" onClick={closeDropdown}>{t.sub_app_dev}</Link></li>
                                <li><Link to="/services/dashboard" onClick={closeDropdown}>{t.sub_data_analysis}</Link></li>
                                <li><Link to="/services/tutorial" onClick={closeDropdown}>{t.sub_tutorial}</Link></li>
                                <li><Link to="/services/electrical" onClick={closeDropdown}>{t.sub_electrical}</Link></li>
                            </>
                        )}

				        {/*<li className="section-title">— {t.nav_contact}/{t.nav_download} —</li>*/}
                        <li><Link to="/contact" onClick={closeDropdown}>{t.nav_contact}</Link></li>
                        <li><Link to="/download1" onClick={closeDropdown}>{t.nav_download}</Link></li>
                        <li><Link to="/login-signup" className="logout-btn" onClick={closeDropdown}>{t.nav_login_signup}</Link></li>
                    </>
                )}
            </ul>
        </header>
    );
};

export default Header;
